import { getCurrentBalance } from "../../js/api/balance.js";
import { createUser, getUsers, userhierarchyforall } from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
let role = localStorage.getItem("role");

function onlyUnique(array, key) {
  return [...new Map(array.map(item => [item[key], item])).values()];
}
var parent_id = null;

let CreateUsers = {
  render: async () => {
    let createRoleBased = '';
    let managersList = null;
    let agentsList = null;
  
    if (location.hash.toString().indexOf('?type=') > -1) {
      createRoleBased = location.hash.toString().split('?type=')[1];

      if (createRoleBased == 'User' || createRoleBased == 'Agent') {
        $('.main-form').addClass('block-view');
        const res = await getUsers();
        if (res?.data && res.data.children_users.length > 0) {
          managersList = onlyUnique(res.data.children_users, 'username');
        }
      }
    }

    let view = /*html*/ `
            <div class="createUsersHeader">
              <a class="backBtn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
              </a>
              <span>${_t('Krijo Perdorues te ri')}</span>
           </div>
           <div class="createUsersWrapper m-t-6">
              <div class="createUsersHolder select-manager-form m-t-6" ${createRoleBased == 'Agent' || createRoleBased == 'User' ? '' : 'hidden'}>
                <div class="form-group">
                  <label for="selectManager">${_t('Zgjidh Menaxherin')}</label>
                  <select name="selectManager" id="selectManager">
                    <option selected disabled>${_t('Zgjidh Menaxherin')}</option>
                    ${
                      managersList ? managersList.map((manager) => {
                        return `<option value="${manager.id}">${manager.username}</option>`;
                      }).join('') : ''
                    }
                  </select>
                </div>
              </div>
              <div class="createUsersHolder select-agent-form m-t-6 ${managersList ? "block-view" : ""}" ${createRoleBased == 'User' ? '' : 'hidden'}>
                <div class="form-group">
                  <label for="selectAgent">${_t('Zgjidh Agjentin')}</label>
                  <select name="selectAgent" id="selectAgent">
                  </select>
                </div>
              </div>
              <div class="createUsersHolder main-form m-t-6 ${managersList ? "block-view" : ""}">
                <div class="form-group">
                  <input type="text" placeholder="${_t('Perdoruesi')}" id="txtUsername">
                  <input type="password" placeholder="${_t('Fjalekalimi')}" id="txtPassword">
                </div>
                <div class="form-group">
                  <input type="text" placeholder="${_t('Emri')}" id="txtFirstName">
                  <input type="text" placeholder="${_t('Mbiemri')}" value="" id="txtSurname">
                </div>
                  ${['Administrator', 'Supermanager'].includes(role) && (!!createRoleBased && createRoleBased !== 'User') ? `
                    <div class="form-group inline">
                      <label for="txtSinglePercentage">% - 1</label>
                      <input type="number" placeholder="% - 1" value="4" id="txtSinglePercentage">
                    </div>
                    <div class="form-group inline">
                      <label for="txtDoublePercentage">% - 2</label>
                      <input type="number" placeholder="% - 2" value="8" id="txtDoublePercentage">
                    </div>
                    <div class="form-group inline">
                      <label for="txtTriplePercentage">% - 3</label>
                      <input type="number" placeholder="% - 3" value="8" id="txtTriplePercentage">
                    </div>`: ""
                  }
                  <div class="form-group">
                    <select name="" id="selectCurrency">
                    </select>
                  </div>

                  <a class="updateCreateUserBtn" id="createUserBtn" style="margin-top: 0; margin-bottom: 15px">${_t('Regjistrohu')}</a>
              </div>
          </div>
       `;
    return view;
  },
  after_render: async () => {
    var currentBalanceResult = await getCurrentBalance();

    if (role == "Supermanager" || role == "Manager" || role == "Administrator" || role == "Superadmin" || role == "CompanyAdmin") {
      $("#selectCurrency").append(`<option value="0"> 
        ${_t('Të gjitha')}
      </option>`);
    }

    if (currentBalanceResult.total_coins.includes('|')) {
      var allCoins = currentBalanceResult.total_coins.split('|');

      allCoins.forEach((element) => {
        const currencyId = element.split(';')[0].split('.')[0];
        const currency = element.split(';')[0].split('.')[1];

        $("#selectCurrency").append(`<option value="${currencyId}"> 
         ${currency}
        </option>`);
      });
    } else {
      if (currentBalanceResult.currency) {
        $("#selectCurrency").append(`<option value="${currentBalanceResult.currency_id}"> 
        ${Utils.currencyCode(currentBalanceResult.currency)}
      </option>`);
      } else {
        const currency = currentBalanceResult.total_coins.split(';')[0].split('.')[1];
        const value = currentBalanceResult.total_coins.split(';')[1];
        const id = currentBalanceResult.total_coins.split(';')[0].split('.')[0];
        $("#selectCurrency").append(`<option value="${id}"> 
        ${currency}
      </option>`);
      }

    }

    $('#selectManager').unbind('change');
    $('#selectManager').on('change', async function () {
      if (!$('.main-form').hasClass('block-view')) {
        $('.main-form').addClass('block-view');
      }

      if ($('.select-agent-form').attr('hidden') == 'hidden') {
        $('.main-form').removeClass('block-view');
        parent_id = $(this).val();
        return;
      }

      $('#selectAgent').html('');
      $('#selectAgent').append(`<option selected disabled>${_t('Zgjidh Agjentin')}</option>`);
      const managerId = $(this).val();
      const res = await userhierarchyforall(managerId);
      

      if (res?.data && res.data.children_users.length > 0) {
        const agents = onlyUnique(res.data.children_users, 'username');
        agents.forEach((agent) => {
          $('#selectAgent').append(`<option value="${agent.id}">${agent.username}</option>`);
        });
        $('.select-agent-form').removeClass('block-view');
      }
    });

    $('#selectAgent').unbind('change');
    $('#selectAgent').on('change', function () {
      $('.main-form').removeClass('block-view');
      parent_id = $(this).val();
    });


    //name,surname,username,email,password,currency


    const submitBtn = document.getElementById('createUserBtn');
    if (submitBtn) {
      $('createUserBtn').unbind('click');
      submitBtn.addEventListener('click', async () => {
        const Username = document.getElementById("txtUsername").value;
        const Password = document.getElementById("txtPassword").value;
        const FirstName = document.getElementById("txtFirstName").value;
        const Surname = document.getElementById("txtSurname").value;
        const Currency = document.getElementById("selectCurrency").value;
        const singlePercentage = document.getElementById("txtSinglePercentage") ? document.getElementById("txtSinglePercentage").value : "0";
        const doublePercentage = document.getElementById("txtDoublePercentage") ? document.getElementById("txtDoublePercentage").value : "0";
        const triplePercentage = document.getElementById("txtTriplePercentage") ? document.getElementById("txtTriplePercentage").value : "0";

        const reqData = {
          name: FirstName,
          surname: Surname,
          currency: Currency,
          password: Password,
          username: Username,
          single_percentage: singlePercentage,
          double_percentage: doublePercentage,
          triple_percentage: triplePercentage,
          partner_type: singlePercentage != "0" || doublePercentage != "0" || triplePercentage != "0" ? "turnover_percentage" : "no_percentage"
        }

        if (parent_id) {
          reqData.parent_id = parent_id;
        }

        const result = await createUser(reqData);

        if (result.success) {
          alert(result.error);
          if (result.success == "OK")
            window.location.href = "#/users";
        }
      });
    }
  },
  hideFooterCasino: true
};

export default CreateUsers;
